/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaterialAvailableAtLocation } from '../../models/material-available-at-location';

export interface GetMaterialAvailable$Params {
  workCenterId: number;
}

export function getMaterialAvailable(http: HttpClient, rootUrl: string, params: GetMaterialAvailable$Params, context?: HttpContext): Observable<StrictHttpResponse<MaterialAvailableAtLocation>> {
  const rb = new RequestBuilder(rootUrl, getMaterialAvailable.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MaterialAvailableAtLocation>;
    })
  );
}

getMaterialAvailable.PATH = '/api/v1/SecondaryMaterial/{workCenterId}/materialAvailable';
